import React, { useEffect, useState } from 'react';
import imagbtns from '../../images/brand/uploadimg.svg';
// import bannerimg from '../../images/brand/bannerimgs.svg';
import { Form, Input, Select, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { socialMediaList } from '@utils/contstant';
import { checkuser, updateUserDetails, userLogout } from '../../actions/user';
import { capitalizeFirstLetter } from '@utils/comman';
import CustomPhoneNumber from '@components/Comman/CustomPhoneNumber/CustomPhoneNumber';
// import { capitalizeFirstLetter } from '@utils/comman';
// const { TextArea } = Input;

export const Updateaccountdetails = () => {
  const [profilePic, setProfilePic] = useState<string | null>(null); // State to hold the image URL
  const user = useSelector((state: any) => state?.Auth?.user || state?.Auth?.data);
  const [profilePhoto, setProfilePhoto] = useState<any>(null); // State to hold the image URL
  const [selectedSocialMedia, setSelectedSocialMedia] = useState<string[]>([]);
  const [socialMediaUrls, setSocialMediaUrls] = useState<{ [key: string]: string }>({});
  const urlPattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
  const [form] = Form.useForm();
  const navigate = useNavigate(); 
  const dispatch = useDispatch();




  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault()
    const file = event.target.files?.[0]; // Get the first file
    setProfilePhoto(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result as string); // Set the image URL to the state
      };
      reader.readAsDataURL(file); // Convert the file to a data URL
    }
  };

  const triggerFileUpload = () => {
    const fileInput = document.getElementById(
      'file-upload'
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Trigger the file input click
    }
  };

  const transformUrls = () => {
    const result: { [key: string]: string } = {};
    selectedSocialMedia.forEach((platform) => {
      // const urlKey = `socialMediaSelection_${platform}`;
      if (socialMediaUrls[platform]) {
        result[platform] = socialMediaUrls[platform]; // Use the platform as key and its URL as value
      }
    });
    return result;
  };


  useEffect(() => {
    setProfilePic((user?.user || user?.data)?.profilePhoto)

    form.setFieldsValue({
      companyName: user?.data?.companyName,
      abn: user?.data?.abn,
      contactName: user?.data?.contactName,
      firstName: user?.data?.firstName,
      lastName: user?.data?.lastName,
      position: user?.data?.position,
      email: user?.data?.email,
      mobileNumber: user?.data?.mobileNumber,
      contactNumber: user?.data?.contactNumber,
      address: user?.data?.address,
      businessCategory: user?.data?.businessCategory,
      // socialMedia: user?.data?.socialMedia,
      plan: user?.data?.yearly === true ? "Yearly" : "Monthly",
      monthly: user?.data?.monthly,
      termsAndConditions: user?.data?.termsAndConditions,
      businessCode: user?.data?.businessCode,
      referrerCode: user?.data?.referrerCode,
      paymentStartDate: user?.data?.paymentStartDate ? moment(user?.data?.paymentStartDate) : null,
      paymentEndDate: user?.data?.paymentEndDate ? moment(user?.data?.paymentEndDate) : null,
    })
  }, [user])

  const onFinish = (values: any) => {
    console.log("form submit ::::::", values)
    // return
    const transformedData = transformUrls();
    const payload: any = {
      firstName: values?.firstName,
      lastName: values?.lastName,
      companyName: values?.companyName,
      contactName: values?.contactName,
      abn: values?.abn,
      position: values?.position,
      email: values?.email,
      mobileNumber: values?.mobileNumber,
      contactNumber: values?.contactNumber,
      address: values?.address,
      profilePhoto: profilePhoto,
      // businessCategory: values?.businessCategory === "other" ? values?.otherBusinessCategory : values?.businessCategory,
      socialMedia: transformedData,
    };
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    dispatch(
      updateUserDetails(payload, (resp: any) => {
        dispatch(checkuser((res:any) => { 
          if(res?.status === 401) {
            sessionStorage.removeItem('token')
            localStorage.removeItem('token')
            dispatch(userLogout((resp: any) => { }))
          } else {
            navigate('/dashboard')
          }
        }));
      })
    );
  };

  const handleSelectSocial = (value: string[]) => {
    setSelectedSocialMedia(value);
  };

  const onFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const handleUrlChange = (platform: string, url: string) => {
    setSocialMediaUrls((prev) => ({
      ...prev,
      [platform]: url,
    }));
  };

  const [isReady, setIsReady] = useState(false); // Track readiness for rendering

  useEffect(() => {
    if (user?.data?.socialMedia) {
      const selectMedia = user.data.socialMedia.map((item: any) =>
        item.platform?.trim()
      );

      const urls = user.data.socialMedia.reduce((acc: any, item: any) => {
        acc[item.platform] = item.url;
        return acc;
      }, {});

      // Only update state if there's a change
      if (JSON.stringify(selectMedia) !== JSON.stringify(selectedSocialMedia)) {
        setSelectedSocialMedia(selectMedia);
      }
      setSocialMediaUrls(urls);
      setIsReady(true); // Mark as ready after data is set
    }
  }, [user]);

  // Conditional rendering based on readiness
  if (!isReady) {
    return <Spin>Loading</Spin>; // Show a loading spinner or similar
  }

  return (
    <Form className="formControl"
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFailed}
      initialValues={{
        companyName: user?.data?.companyName,
        abn: user?.data?.abn,
        contactName: user?.data?.contactName,
        firstName: user?.data?.firstName,
        lastName: user?.data?.lastName,
        position: user?.data?.position,
        email: user?.data?.email,
        mobileNumber: user?.data?.mobileNumber,
        contactNumber: user?.data?.contactNumber,
        address: user?.data?.address,
        businessCategory: user?.data?.businessCategory,
        // socialMedia: selectedSocialMedia,
        plan: user?.data?.yearly === true ? "Yearly" : "Monthly",
        monthly: user?.data?.monthly,
        termsAndConditions: user?.data?.termsAndConditions,
        businessCode: user?.data?.businessCode,
        referrerCode: user?.data?.referrerCode,
        paymentStartDate: user?.data?.paymentStartDate ? moment(user?.data?.paymentStartDate) : null,
        paymentEndDate: user?.data?.paymentEndDate ? moment(user?.data?.paymentEndDate) : null,
      }}
      >
      <div className="uploadprofileimg">
        <div>
          <div className="profile-pic-container">
            <img
              src={profilePic ? profilePic : imagbtns} // Use a placeholder if no image is selected
              alt="Profile"
              className="profile-pic"
              style={{
                width: '150px',
                height: '150px',
                borderRadius: '50%',
              }}
            />
          </div>
          <input
            type="file"
            id="file-upload"
            accept="image/*"
            style={{ display: 'none' }} // Hide the file input
            onChange={(evt: any) => handleImageChange(evt)}
          />
          <button
            type='button'
            onClick={() => triggerFileUpload()}
            className="upload-button"
          >
            Upload Image
          </button>
        </div>

        <div className="textsides">
          <h6>Profile Image</h6>
          <p>The Image should be 150*150 px not bigger than 1 MB</p>
        </div>
      </div>
      <div className="row">
        {user?.data?.roleId !== 2 ? <div className="col-lg-6 col-sm-12">
          <Form.Item
            className="formControlDesign"
            label="First Name "
            name="firstName"
          >
            <Input />
          </Form.Item>
        </div> : ""}
        {user?.data?.roleId !== 2 ? <div className="col-lg-6 col-sm-12">
          <Form.Item
            className="formControlDesign"
            label="Last Name"
            name="lastName"
          >
            <Input />
          </Form.Item>
        </div> : ""}
        <div className="col-lg-6 col-sm-12">
          <Form.Item
            className="formControlDesign"
            label="Email"
            name="email"
          >
            <Input disabled />
          </Form.Item>
        </div>
        <div className="col-lg-6 col-sm-12">
          <CustomPhoneNumber isRequired={true} label="Contact Number" name="mobileNumber" />
        </div>
        <div className="col-lg-12 col-sm-12">
          <Form.Item
            className="formControlDesign"
            label="Address"
            name="address"
          >
            <Input />
          </Form.Item>
        </div>
        
        <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="contactName"
            label="Contact Name"
            className="formControlDesign"
          >
            <Input placeholder='Contact Name' />
          </Form.Item>
        </div>
        <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="position"
            label="Position"
            className="formControlDesign"
          >
            <Input />
          </Form.Item>
        </div>
        
        {/* <div className="col-lg-6 col-sm-12">
          <CustomPhoneNumber isRequired={false} label="Contact Mobile Number" name="contactNumber" />
          
        </div> */}

        <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="plan"
            label="Plan"
            className="formControlDesign"
          >
            <Input disabled />
          </Form.Item>
        </div>
        <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="socialMedia"
            label="Social Media"
          >
            <Select
              mode="multiple"
              placeholder="Select Social Media"
              onChange={handleSelectSocial}
              className='formControlDesign'
              defaultValue={selectedSocialMedia} // Ensure this is an array with default values
            >
              {socialMediaList.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
            <span style={{display: 'none'}}>{selectedSocialMedia}</span>
          </Form.Item>
          {selectedSocialMedia.map((platform: any, index: number) => {
            let urlValue = socialMediaUrls?.[platform]
            return <div key={platform} className="socialmedias">
              <div className="socialicons">
              {platform === 'facebook' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
                  <path d="M7.98017 21.4074V11.805H11.202L11.6854 8.06171H7.98017V5.67213C7.98017 4.58869 8.2798 3.85034 9.83522 3.85034L11.8158 3.84952V0.501355C11.4733 0.456845 10.2976 0.354797 8.92914 0.354797C6.07167 0.354797 4.11539 2.09897 4.11539 5.3014V8.06171H0.883789V11.805H4.11539V21.4074H7.98017Z" fill="#F47523" />
                </svg>}
                {platform === 'instagram' && <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <path d="M20.9796 6.17406C20.9304 5.05825 20.75 4.29114 20.4915 3.62643C20.2249 2.92085 19.8146 2.28915 19.2772 1.76402C18.752 1.23071 18.1162 0.816306 17.4188 0.553819C16.7502 0.295338 15.9871 0.114898 14.8713 0.0657019C13.7472 0.0123391 13.3903 0 10.5391 0C7.68801 0 7.33113 0.0123391 6.21116 0.0615355C5.09535 0.110732 4.32824 0.291332 3.66369 0.549653C2.95796 0.816306 2.32626 1.22654 1.80112 1.76402C1.26782 2.28915 0.853575 2.92502 0.590928 3.62242C0.332447 4.29114 0.152007 5.05408 0.102811 6.16989C0.0494485 7.29403 0.0371094 7.65091 0.0371094 10.5021C0.0371094 13.3532 0.0494485 13.7101 0.0986447 14.83C0.147841 15.9459 0.328441 16.713 0.586921 17.3777C0.853575 18.0833 1.26782 18.7149 1.80112 19.2401C2.32626 19.7734 2.96212 20.1878 3.65952 20.4503C4.32824 20.7088 5.09118 20.8892 6.20715 20.9384C7.32697 20.9878 7.684 20.9999 10.5351 20.9999C13.3863 20.9999 13.7431 20.9878 14.8631 20.9384C15.9789 20.8892 16.746 20.7088 17.4106 20.4503C18.8219 19.9046 19.9377 18.7888 20.4834 17.3777C20.7417 16.709 20.9223 15.9459 20.9715 14.83C21.0207 13.7101 21.033 13.3532 21.033 10.5021C21.033 7.65091 21.0288 7.29403 20.9796 6.17406ZM19.0886 14.748C19.0434 15.7736 18.8711 16.3274 18.7275 16.6966C18.3746 17.6115 17.6486 18.3376 16.7337 18.6904C16.3645 18.834 15.8067 19.0063 14.7851 19.0513C13.6774 19.1007 13.3453 19.1128 10.5433 19.1128C7.74137 19.1128 7.40501 19.1007 6.30138 19.0513C5.27579 19.0063 4.72197 18.834 4.35276 18.6904C3.89749 18.5222 3.48309 18.2555 3.14673 17.9068C2.79803 17.5663 2.53137 17.1561 2.36311 16.7008C2.21953 16.3316 2.04726 15.7736 2.00223 14.7522C1.95288 13.6445 1.9407 13.3122 1.9407 10.5102C1.9407 7.70828 1.95288 7.37192 2.00223 6.26844C2.04726 5.24285 2.21953 4.68903 2.36311 4.31982C2.53137 3.86439 2.79803 3.45015 3.15089 3.11363C3.49126 2.76493 3.9015 2.49828 4.35692 2.33017C4.72614 2.18659 5.28412 2.01432 6.30554 1.96913C7.41318 1.91994 7.74554 1.9076 10.5473 1.9076C13.3534 1.9076 13.6856 1.91994 14.7893 1.96913C15.8148 2.01432 16.3687 2.18659 16.7379 2.33017C17.1931 2.49828 17.6075 2.76493 17.9439 3.11363C18.2926 3.45416 18.5593 3.86439 18.7275 4.31982C18.8711 4.68903 19.0434 5.24686 19.0886 6.26844C19.1377 7.37608 19.1501 7.70828 19.1501 10.5102C19.1501 13.3122 19.1377 13.6404 19.0886 14.748Z" fill="#F47523" />
                  <path d="M10.5391 5.10748C7.56092 5.10748 5.14453 7.52371 5.14453 10.5021C5.14453 13.4805 7.56092 15.8967 10.5391 15.8967C13.5175 15.8967 15.9337 13.4805 15.9337 10.5021C15.9337 7.52371 13.5175 5.10748 10.5391 5.10748ZM10.5391 14.0014C8.60702 14.0014 7.03979 12.4344 7.03979 10.5021C7.03979 8.56981 8.60702 7.00274 10.5391 7.00274C12.4714 7.00274 14.0385 8.56981 14.0385 10.5021C14.0385 12.4344 12.4714 14.0014 10.5391 14.0014V14.0014Z" fill="#F47523" />
                  <path d="M17.4067 4.89413C17.4067 5.58961 16.8427 6.15353 16.1471 6.15353C15.4516 6.15353 14.8877 5.58961 14.8877 4.89413C14.8877 4.19849 15.4516 3.63474 16.1471 3.63474C16.8427 3.63474 17.4067 4.19849 17.4067 4.89413V4.89413Z" fill="#F47523" />
                </svg>}
                {(platform === 'linkedIn' || platform === 'linkedin') && <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                  <g clip-path="url(#clip0_730_815)">
                    <path d="M20.9946 21V20.9992H20.9999V13.2974C20.9999 9.52966 20.1888 6.62729 15.784 6.62729C13.6665 6.62729 12.2455 7.78929 11.6654 8.89091H11.6041V6.97904H7.42773V20.9992H11.7765V14.0569C11.7765 12.229 12.123 10.4615 14.3866 10.4615C16.617 10.4615 16.6503 12.5475 16.6503 14.1742V21H20.9946Z" fill="#F47523" />
                    <path d="M0.34668 6.97986H4.70068V21H0.34668V6.97986Z" fill="#F47523" />
                    <path d="M2.52175 0C1.12963 0 0 1.12963 0 2.52175C0 3.91387 1.12963 5.06712 2.52175 5.06712C3.91387 5.06712 5.0435 3.91387 5.0435 2.52175C5.04262 1.12963 3.913 0 2.52175 0V0Z" fill="#F47523" />
                  </g>
                  <defs>
                    <clipPath id="clip0_730_815">
                      <rect width="21" height="21" fill="white" />
                    </clipPath>
                  </defs>
                </svg>}
              </div>
              <Form.Item
                name={`socialMediaSelection_${platform}`} // Unique name for each input
                className='formControlDesign'
                rules={[
                  {
                    pattern: urlPattern,
                    message: 'Please enter a valid URL!',
                  },
                ]}
              >
                <Input
                  value={urlValue} // Use value instead of defaultValue
                  placeholder={`${platform && capitalizeFirstLetter(platform)} URL`}
                  onChange={(evt) => handleUrlChange(platform, evt.target.value)}
                />
                <span style={{ display: 'none'}}>{urlValue}</span>
              </Form.Item>
            </div>
          })}
        </div>

        {/* <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="businessCode"
            label="Business Code"
            className="formControlDesign"
          >
            <Input disabled />
          </Form.Item>
        </div> */}
        {/* <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="referrerCode"
            label="Referrer Code"
            className="formControlDesign"
          >
            <Input disabled />
          </Form.Item>
        </div> */}
        {/* <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="paymentStartDate"
            label="Payment Start Date"
            className="formControlDesign"
          >
            <Input disabled />
          </Form.Item>
        </div>
        <div className="col-lg-6 col-sm-12">
          <Form.Item
            name="paymentEndDate"
            label="Payment End Date"
            className="formControlDesign"
          >
            <Input disabled />
          </Form.Item> 
        </div> */}

        {/* <div className="col-lg-6 col-sm-12">
                    <Form.Item
                        name="Business Category"
                        label="State"
                        className="formControlDesign"
                    >
                        <Select placeholder="State">
                            <Select.Option value="A">items</Select.Option>
                        </Select>
                    </Form.Item>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <Form.Item
                        name="Country"
                        label="Country"
                        className="formControlDesign"
                    >
                        <Select placeholder="Country">
                            <Select.Option value="A">items</Select.Option>
                        </Select>
                    </Form.Item>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <Form.Item
                        className="formControlDesign"
                        label="Pincode"
                        name="Pincode"
                    >
                        <Input />
                    </Form.Item>
                </div> */}

        <div className="col-lg-12 mt-15">
          <div className="text-end btn-groups-Forms">
            <button className="btn btn-outline-primary">
              Cancel
            </button>
            <button className="btn btn-primary">Save</button>
          </div>
        </div>
      </div>
    </Form>
  );
};
